/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useState} from 'react'
import {useIntl} from 'react-intl'
import {toAbsoluteUrl} from '../../../_metronic/helpers'
import {PageTitle} from '../../../_metronic/layout/core'
import {useParams, Link} from 'react-router-dom'
import {CheckPodAccess, FindFirstPodCode} from '../../modules/FindPodIdByPodCode'
import {useAuth} from '../../modules/auth'
import Dashboard from './Dashboard'
import {DocsMain} from '../../modules/documents/DocsMain'
import {DraftsTable} from '../../modules/documents/Drafts'

const DashboardWrapper: FC = () => {
  const intl = useIntl()
  const {id} = useParams()
  const dashboard = [
    {
      title: `(${id})`,
      path: `/${id}/dashboard`,
      isSeparator: false,
      isActive: false,
    },
  ]

  return (
    <>
      <PageTitle breadcrumbs={dashboard}>{intl.formatMessage({id: 'MENU.DASHBOARD'})}</PageTitle>
      <Dashboard />
      <div className='row g-6'>
        <div className='col-12 col-lg-4'>
          <DraftsTable />
        </div>
        <div className='col-12 col-lg-8'>
          <DocsMain />
        </div>
      </div>
    </>
  )
}

export {DashboardWrapper}
